import { Button } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

interface MdaApplyFiltersButtonProps {
  disabled: boolean;
  onClick: () => Promise<void>;
}

const MdaApplyFiltersButton = ({
  disabled,
  onClick,
}: MdaApplyFiltersButtonProps) => (
  <Button
    variant="contained"
    disabled={disabled}
    onClick={onClick}
    startIcon={<FilterAltOutlinedIcon sx={{ fontSize: 18 }} />}
    sx={{
      minHeight: 40,
      px: 2,
      backgroundColor: "#1769ff",
      textTransform: "none",
      fontWeight: 700,
      whiteSpace: "nowrap",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#0757df",
        boxShadow: "none",
      },
    }}
  >
    Apply filters
  </Button>
);

export default MdaApplyFiltersButton;
